import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'

// Consulta o status do pagamento; quando aprova, o servidor devolve um
// Turbo Stream "visit" para a próxima página.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 4000 } }

  connect() {
    this.timer = setInterval(() => this.poll(), this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: 'text/vnd.turbo-stream.html' },
        credentials: 'same-origin'
      })
      if (response.status === 204 || !response.ok) return
      const html = await response.text()
      if (html) Turbo.renderStreamMessage(html)
    } catch {
      // silencioso: o comprador pode recarregar
    }
  }
}
